import instance from "../axios";

const uri = {
    userloginSignUp: "/auth/login-phone",
    otpConfirmation: "/auth/confirm-otp",
    profileImageUpdate: "/auth/profile-pic",
    createProfileUser: "/auth/profile-update",
    resendOTPWhatSap: "/auth/resend-otp-whatsapp",
    profileDetails: "auth/user-details",
    getUpcomingBooking: "/vendor-flight/booking-list/upcoming",
    getcomplitedBooking: "/vendor-flight/booking-list/complited",
    getcancelledBooking: "/vendor-flight/booking-list/cancelled",
    getUpcomingBookingHotel: "/hotel/get-hotel-booking/upcoming",
    getcomplitedBookingHotel: "hotel/get-hotel-booking/complited",
    getcancelledBookingHotel: "hotel/get-hotel-booking/cancelled",
    BookingDetailById: "/payment/booking-detail",
    BookingPdf: "/payment/get-pdf",
    hotelBookingDetailById: "hotel/booking-details",
    getHotelBookingPdf: "hotel/get-pdf",
    donwloadTicket: "payment/get-mail-pdf",
    getHolidayEnquiryList: "/package/holiday-booking-list",
};


export const getUserloginSignUp = async (reqBody) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.userloginSignUp, reqBody, {
            headers: headers,
        });
        return response;
    } catch (error) {
        console.error('Error fetching hotel search data:', error);
        throw error;
    }
};

export const getOtpConfirmation = async (reqBody) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.otpConfirmation, reqBody, {
            headers: headers,
        });
        return response;
    } catch (error) {
        console.error('Error fetching hotel search data:', error);
        throw error;
    }
};


export const fetchProfileImageUpdate = async (reqBody) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };
    try {
        const response = await instance.post(uri.profileImageUpdate, reqBody, {
            headers: headers,
        });
        return response;
    } catch (error) {
        console.error('Error fetching hotel search data:', error);
        throw error;
    }
};

export const getProfileCreateUser = async (reqBody) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };
    try {
        const response = await instance.put(uri.createProfileUser, reqBody, {
            headers: headers,
        });
        return response;
    } catch (error) {
        console.error('Error fetching hotel search data:', error);
        throw error;
    }
};


export const getUserResendOtpWhatsapp = async (reqBody) => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY,
    };

    try {
        const response = await instance.post(uri.resendOTPWhatSap, reqBody, {
            headers: headers,
        });
        return response;
    } catch (error) {
        console.error('Error fetching hotel search data:', error);
        throw error;
    }
};

export const getProfileDetails = async () => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };

    try {
        const response = await instance.get(uri.profileDetails, { headers: headers, });
        return response.data;
    } catch (error) {
        console.error('Error fetching profile:', error);
        throw error;
    }
};



export const getUpcomingBookingFlights = async () => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };

    try {
        const response = await instance.get(uri.getUpcomingBooking, { headers: headers, });
        return response.data;
    } catch (error) {
        console.error('Error fetching profile:', error);
        throw error;
    }
};


export const getCancelledBookingFlights = async () => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };

    try {
        const response = await instance.get(uri.getcancelledBooking, { headers: headers, });
        return response.data;
    } catch (error) {
        console.error('Error fetching profile:', error);
        throw error;
    }
};


export const getcomplitedBookingFlights = async () => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };

    try {
        const response = await instance.get(uri.getcomplitedBooking, { headers: headers, });
        return response.data;
    } catch (error) {
        console.error('Error fetching profile:', error);
        throw error;
    }
};


export const getUpcomingBookingHotels = async () => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };

    try {
        const response = await instance.get(uri.getUpcomingBookingHotel, { headers: headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching upcoming hotel bookings:', error);
        throw error;
    }
};

export const getCancelledBookingHotels = async () => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };

    try {
        const response = await instance.get(uri.getcancelledBookingHotel, { headers: headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching cancelled hotel bookings:', error);
        throw error;
    }
};

export const getCompletedBookingHotels = async () => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };

    try {
        const response = await instance.get(uri.getcomplitedBookingHotel, { headers: headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching completed hotel bookings:', error);
        throw error;
    }
};


export const getBookingDetailById = async (id) => {
    try {
        const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
        const headers = {
            'api-key': API_KEY,
        };
        const response = await instance.get(`${uri.BookingDetailById}/${id}`, { headers });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};



export const getBookingPdf = async (id) => {
    try {
        const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
        const headers = {
            'api-key': API_KEY,
        };
        const response = await instance.get(`${uri.BookingPdf}/${id}`, {
            headers,
            responseType: 'blob',
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};


export const getHotelBookingDetailById = async (id) => {
    try {
        const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
        const headers = {
            'api-key': API_KEY,
        };
        const response = await instance.get(`${uri.hotelBookingDetailById}/${id}`, { headers });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};



export const getHotelBookingPdf = async (id) => {
    try {
        const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
        const headers = {
            'api-key': API_KEY,
        };
        const response = await instance.get(`${uri.getHotelBookingPdf}/${id}`, {
            headers,
            responseType: 'blob',
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;

    };
}




export const getDownloadTicketPDFById = async (id) => {
    try {
        const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
        const headers = {
            'api-key': API_KEY,
        };
        const response = await instance.get(`${uri.donwloadTicket}/${id}`, {
            headers,
            responseType: 'blob',
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;

    };
}

export const getHolidayEnquiryList = async () => {
    const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
    const headers = {
        'api-key': API_KEY
    };

    try {
        const response = await instance.get(uri.getHolidayEnquiryList, { headers: headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching upcoming hotel bookings:', error);
        throw error;
    }
};